// COPY de apps/desktop/src/...; dedup em F13 via packages/shared-ui.
interface SpinnerProps {
  label?: string;
}

export function Spinner({ label }: SpinnerProps) {
  return (
    <span role="status" aria-live="polite" className="row">
      <span className="ds-spinner" aria-hidden />
      {label !== undefined ? <span className="muted">{label}</span> : null}
    </span>
  );
}
